import { EProviderType } from './provider';

export interface INewbuildingPromo {
  newbuildingId: number;
  newbuildingImage: string;
  newbuildingName: string;
  newbuildingUrl: string;
  promoInfoList: IPromoInfo[];
  promoName: string;
  providerPromoId: number;
  providerType: EProviderType;
}

export interface IPromoInfo {
  promoType: EPromoType;
}

export enum EPromoType {
  Bonus = 'bonus',
  CianMortgage = 'cianMortgage',
  Discount = 'discount',
  MaternalCapital = 'maternalCapital',
  Military = 'military',
  Mortgage = 'mortgage',
}
